/* eslint-disable */
export default {
  inAMeeting: 'In einer Besprechung',
  onMyWay: 'Bin unterwegs',
  callMeBackIn: 'Rufen Sie mich zurück in …',
  willCallYouBackIn: 'Ich rufe Sie zurück in …',
  hour: 'Stunde',
  min: 'Min.',
} as const;

// @key: @#@"inAMeeting"@#@ @source: @#@"In a meeting"@#@
// @key: @#@"onMyWay"@#@ @source: @#@"On my way"@#@
// @key: @#@"callMeBackIn"@#@ @source: @#@"Call me back in..."@#@
// @key: @#@"willCallYouBackIn"@#@ @source: @#@"Will call you back in..."@#@
// @key: @#@"hour"@#@ @source: @#@"hour"@#@
// @key: @#@"min"@#@ @source: @#@"min"@#@
